import React from 'react';
import styled from 'styled-components';
import { rgba, darken, lighten } from 'polished';

const Styled = styled.div`
  float: left;
  padding: 15px;
  margin-right: 15px;
  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};
  position: relative;
  top: -15px;
  border-radius: 3px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BoxHeaderIcon = ({ children, style, color = '#ffffff' }) => {
  return (
    <Styled style={{ ...style }} color={color}>
      {children}
    </Styled>
  );
};

export default BoxHeaderIcon;
